export default __webpack_public_path__ + "static/media/img_test1.2b4c20bb.svg";